var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAwsS3Icon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.17823 0.703828L18.0001 5.11786V14.2149L9.00004 18.7185L0 14.2149V5.11786L9.00004 0.614258L9.17823 0.703828ZM9.40122 9.91287V17.6243L17.1977 13.7233V6.01189L9.40122 9.91287ZM8.59881 17.6243V9.91287L0.802358 6.01189V13.7233L8.59881 17.6243ZM1.29416 5.36436L9.00009 9.21971L16.706 5.3634L9.00009 1.50805L1.29416 5.36436Z",
    fill: "#EF7707"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwsS3Icon);
export default __webpack_public_path__ + "static/media/aws_s3_icon.923e01ec0b9500aa39089fe5ebb05912.svg";
export { ForwardRef as ReactComponent };